(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    (function() {
    function initProductTabs() {
      var tabsContainers = document.querySelectorAll('.product_tabs');
      
      tabsContainers.forEach(function(tabsContainer) {
        var tabItems = tabsContainer.querySelectorAll('.tab_item');
        var tabPanels = tabsContainer.querySelectorAll('.tab_panel');

        tabItems.forEach(function(tabItem) {
          tabItem.addEventListener('click', function(e) {
            e.preventDefault();
            
            var targetTabId = this.getAttribute('data-tab');
            
            // Remove active class from all tabs and panels in this container
            tabItems.forEach(function(item) {
              item.classList.remove('active');
            });
            
            tabPanels.forEach(function(panel) {
              panel.classList.remove('active');
            });
            
            // Add active class to clicked tab and corresponding panel
            this.classList.add('active');
            var targetPanel = document.getElementById(targetTabId);
            if (targetPanel) {
              targetPanel.classList.add('active');
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductTabs);
    } else {
      initProductTabs();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
